const ownershipTypeDisplayNameMap = {
  USUF: 'Usufructuary',
  OWNR: 'Owner',
  BOWN: 'Bare owner',
};

export default function (ownershipTypeEnum) {
  return ownershipTypeDisplayNameMap[ownershipTypeEnum];
}
